
<script>

import Vue from 'vue'
import { BootstrapVue } from 'bootstrap-vue'

import './assets/app.scss'
Vue.use(BootstrapVue)
export default {
  name: 'App'
}
</script>
<template>
  <div id="main-app">
    <router-view />
  </div>
</template>
<style>
body{color:white;}
.btn,.btn:hover,.btn:active{
  color: #09A881 !important;
}
.btn-own{
  width:315px;
  border-radius: 45px;
  font-size: 25px;
  line-height: 25px;
}

.btn-violet{
  color:#a500f8 !important;
}

</style>
